


















import { Component, Vue, Prop } from 'vue-property-decorator';
import { Debounced } from '@/utils/debounced';
import {searchIssues} from '@/utils/issue';

type IIssueInfo = IIssue.IResponse.IIssueInfo;
type IGetIssues = IIssue.IRequest.IGetIssues;

@Component
export default class SelectProject extends Vue {
  @Prop({default: () => ({})}) private search!: IGetIssues;
  private fetching: boolean = false;
  private issueOptions: IIssueInfo[] = [];
  private debouncedFetchIssue: (
    searchVal: string,
  ) => void = new Debounced().use(this.searchIssue, 1000); // 节流函数
  public searchIssueById(issueId: string) {
    this.fetching = true;
    searchIssues({
      id: issueId,
    }).then((res) => {
      this.fetching = false;
      this.issueOptions = res.data;
    }).catch((err) => {
      this.fetching = false;
      this.$message.warning(err);
    });
  }
  // 触发搜索需求方法
  private fetchIssue(searchVal: string) {
    this.debouncedFetchIssue(searchVal);
  }
  // 请求需求数据
  private searchIssue(searchVal: string) {
    this.fetching = true;
    const searchTxt = searchVal.trim();
    const params: IGetIssues = {};
    if (searchTxt) {
      params.keyword = searchTxt;
    }
    Object.assign(params, this.search);
    searchIssues(params).then((res) => {
      this.fetching = false;
      this.issueOptions = res.data;
    }).catch((err) => {
      this.fetching = false;
      this.$message.warning(err);
    });
  }
  // 处理选项改变
  private handleChange(value: string) {
    const requirementInfo = this.issueOptions.find((option) => option.id === value) || null;
    this.$emit('change', requirementInfo);
  }
}
